module.exports = __webpack_public_path__ + "static/img/042_6.7347ae8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/042_6.jpg
// module id = 9bbL
// module chunks = 1